import styled from "styled-components";
import {
  compose,
  //
  space,
  color,
  typography,
  layout,
  flexbox,
  grid,
  background,
  border,
  position,
  shadow,
  size,
} from "styled-system";

const styledSystem = (tag) => {
  return styled(tag)(
    compose(
      space,
      color,
      typography,
      layout,
      flexbox,
      grid,
      background,
      border,
      position,
      shadow,
      size
    )
  );
};

export default styledSystem;
